import SearchForm from './SearchForm'
import Router from 'next/router'
import { toolFormInputsMobile, toolFormInputs } from '@components/search/toolFormInputs'
import { TOOL_LINK_BASE } from '@constants/searchFormLinks'
import searchFormLink from '@utils/links/searchFormLink'

const ToolForm = ({ overrideDefaultValues }) => {
    const navigateToSearchPage = (data) => {
        const link = searchFormLink({
            data,
            linkBase: TOOL_LINK_BASE,
            isMakeModelBase: false,
        })

        Router.push(link)
    }

    return <SearchForm
        inputs={toolFormInputs}
        mobileInputs={toolFormInputsMobile}
        dataKey="tool"
        overrideDefaultValues={overrideDefaultValues}
        onSubmit={navigateToSearchPage}
        actionBar={{
            paliwo: null,
            clear: true,
            advancedOptions: null,
        }} />
}

export default ToolForm